// 美容師基本情報実績職歴無し時のgrayアウト
$(function () {
	function grayoutHistoryInput(){
		$('.gray-wrap').addClass('gray-out');
		$('.gray-out-con').prop("disabled", true);
	}

	if ($('[id=flg_beautician_license-no]').prop('checked')) {
		grayoutHistoryInput();
	}

	$('[name="flg_beautician_license"]:radio').change(function () {
		if ($('[id=flg_beautician_license-no]').prop('checked')) {
			grayoutHistoryInput();
		} else if ($('[id=flg_beautician_license-yes]').prop('checked')) {
			$('.gray-wrap').removeClass('gray-out');
			$('.gray-out-con').prop("disabled", false);
		}
	});
});